



import React, { useState } from "react";
import { IoArrowBack } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';

const GenerateProductLink = () => {
  const navigate = useNavigate();
  const influencerId = localStorage.getItem("influencerID");

  const [productUrl, setProductUrl] = useState("");
  const [shortLink, setShortLink] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [copied, setCopied] = useState(false);
  const handleGenerateLink = async () => {
  setLoading(true);
  setShortLink("");
  setError("");
  setCopied(false);

  if (!productUrl.trim()) {
    setError("Please enter a product URL.");
    toast.error("Please enter a product URL.");
    setLoading(false);
    return;
  }

  try {
    const res = await fetch("https://server-side-influencer.onrender.com/influencer/generate-singlelink", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        originalUrl: productUrl.trim(),
        userId: influencerId
      }),
    });

    const data = await res.json();

    if (res.ok) {
      setShortLink(data.shortLink);
      toast.success("Link generated successfully!");
    } else {
      setError(data.message || "Failed to generate link");
      toast.error(data.message || "Failed to generate link");
    }
  } catch (err) {
    setError("Something went wrong.");
    toast.error("Something went wrong.");
    console.error(err);
  } finally {
    setLoading(false);
  }
};

  const handleCopyLink = () => {
    if (!shortLink) return;
    navigator.clipboard.writeText(shortLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="min-h-screen bg-white pb-20">
      {/* Fixed Header */}
      <div className="bg-gray-100 text-black flex items-center justify-between p-4 fixed w-full top-0 left-0 z-50 shadow">
        <div onClick={() => navigate(-1)} className="cursor-pointer flex items-center">
          <IoArrowBack size={24} />
          <span className="ml-2">Back</span>
        </div>
        <div className="w-24" />
      </div>

      {/* Main Content */}
      <div className="pt-20 px-4 max-w-xl mx-auto mt-12">
        <h2 className="text-2xl font-semibold text-center mb-6">
          Generate Product Link
        </h2>

        <input
          type="text"
          value={productUrl}
          onChange={(e) => setProductUrl(e.target.value)}
          placeholder="Enter Amazon product URL"
          className="w-full px-4 py-3 border rounded mb-4"
        />

        <button
          onClick={handleGenerateLink}
          disabled={loading}
          className="w-full shadow-xl py-3 px-4 text-sm tracking-wide rounded-lg text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl flex items-center justify-center gap-1 transition-all duration-300 disabled:opacity-60"
        >
          {loading ? "Creating link..." : "Generate Link"}
        </button>

    

        {shortLink && (
          <div className="mt-6 flex items-center justify-center gap-3">
            <a
              href={shortLink}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline break-all"
            >
              {shortLink}
            </a>
            <button
              onClick={handleCopyLink}
              className="px-3 py-1 text-sm bg-purple-600 hover:bg-purple-700 text-white rounded transition"
            >
              {copied ? "Copied!" : "Copy Link"}
            </button>
          </div>
        )}
      </div>
      <ToastContainer position="top-center" autoClose={3000} />

    </div>
  );
};

export default GenerateProductLink;

